import React, { useEffect } from "react";
import "./Footer.css";

import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt } from "react-icons/fa";
import NavButton from "../header/buttons/navbutton/NavButton";
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AllAppSetup } from "../../features/admin/common/Slice";
import { IDS } from "../../utils/IDS";

const Footer = () => {
  const dispatch = useDispatch();

  const all_app_setup = useSelector((state) => state?.common?.all_app_setup);

  useEffect(() => {
    dispatch(AllAppSetup());
  }, [dispatch]);

  return (
    <footer className="main-footer">
      <img
        src="images\home\Mask Group 11.png"
        alt=""
        className="footer-bg footer-bg-left"
      />

      <img
        src="images\home\Mask Group 12.png"
        alt=""
        className="footer-bg footer-bg-right"
      />

      <div className="container">
        {/* Brand */}
        <div className="footer-brand">
          <img src="images\logo\logo.png" alt="Spirulina" />
        </div>

        {/* Divider */}
        <div className="footer-divider-container">
          <div className="footer-divider" />
        </div>

        {/* Navigation */}
        <ul className="footer-links">
          <li>
            <NavLink
              to="/home"
              end
              className={({ isActive }) =>
                isActive ? "footer-link active" : "footer-link"
              }
            >
              <NavButton text="Homepage" />
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/about"
              className={({ isActive }) =>
                isActive ? "footer-link active" : "footer-link"
              }
            >
              <NavButton text="About Us" />
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/products"
              className={({ isActive }) =>
                isActive ? "footer-link active" : "footer-link"
              }
            >
              <NavButton text="Products" />
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/contact"
              className={({ isActive }) =>
                isActive ? "footer-link active" : "footer-link"
              }
            >
              <NavButton text="Contact Us" />
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/privacy-policy"
              className={({ isActive }) =>
                isActive ? "footer-link active" : "footer-link"
              }
            >
              <NavButton text="Privacy Policy" />
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/terms-conditions"
              className={({ isActive }) =>
                isActive ? "footer-link active" : "footer-link"
              }
            >
              <NavButton text="Terms & Conditions" />
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/return-policy"
              className={({ isActive }) =>
                isActive ? "footer-link active" : "footer-link"
              }
            >
              <NavButton text="Return Policy" />
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/refund-policy"
              className={({ isActive }) =>
                isActive ? "footer-link active" : "footer-link"
              }
            >
              <NavButton text="Refund Policy" />
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/shipping-policy"
              className={({ isActive }) =>
                isActive ? "footer-link active" : "footer-link"
              }
            >
              <NavButton text="Shipping Policy" />
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/cancellation-policy"
              className={({ isActive }) =>
                isActive ? "footer-link active" : "footer-link"
              }
            >
              <NavButton text="Cancellation Policy" />
            </NavLink>
          </li>
        </ul>

        {/* Contact */}
        <div className="footer-contact">
          <div>
            <FaMapMarkerAlt />
            <span>
              {/* Akshya Nagar 1st Block, 1st Cross, Patil Nagar, Pune - 411038 */}
              {all_app_setup?.[0]?.address},{all_app_setup?.[0]?.state}
            </span>
          </div>
          <div className="vertical-divider" />
          <div>
            <span>
              <FaEnvelope />
              Email : {all_app_setup?.[0]?.email}
            </span>
          </div>
          <div className="vertical-divider" />
          <div>
            <span>
              <FaPhoneAlt />
              +91 {all_app_setup?.[0]?.contact_no}
            </span>
          </div>
        </div>
      </div>

      {/* Bottom */}
      <div className="footer-bottom">
        © 2026 Spirulina All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;
